export const getFirstLetters = text =>
  text
    .split(" ")
    .slice(0, 2)
    .map(word => word[0])
    .join("")
